/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductCategoryEnum = {
    New: 'new',
    Migrate: 'migrate',
    Addition: 'addition',
    J: 'J',
    O: 'O'
} as const;
export type ProductCategoryEnum = typeof ProductCategoryEnum[keyof typeof ProductCategoryEnum];


export function instanceOfProductCategoryEnum(value: any): boolean {
    for (const key in ProductCategoryEnum) {
        if (Object.prototype.hasOwnProperty.call(ProductCategoryEnum, key)) {
            if (ProductCategoryEnum[key as keyof typeof ProductCategoryEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductCategoryEnumFromJSON(json: any): ProductCategoryEnum {
    return ProductCategoryEnumFromJSONTyped(json, false);
}

export function ProductCategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryEnum {
    return json as ProductCategoryEnum;
}

export function ProductCategoryEnumToJSON(value?: ProductCategoryEnum | null): any {
    return value as any;
}

export function ProductCategoryEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductCategoryEnum {
    return value as ProductCategoryEnum;
}

